export enum BookingTypeEnum {
    None = 0,
    Regular = 1,
    Fastest = 2,
    ScanAndRide = 3,
	Scheduled = 4,
	DayTrip = 5
}
